import { useState } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from './ArticlesHero.module.scss';
import { PrimaryButton } from '../../../components';
import NewsletterModal from '../NewsletterModal';
import { getSiteUi } from '../../../lib/site-ui';

let cx = classNames.bind(styles);

export default function ArticlesHero({ data, languageCode = 'no' }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!data) return null;

  const ui = getSiteUi(languageCode);
  const { mainHeaderText, smallTopHeader, subText, button } = data;

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section className={cx('heroSection')}>
        <div className={cx('container')}>
          <div className={cx('content')}>
            {smallTopHeader && (
              <span className={cx('smallHeader')}>{smallTopHeader}</span>
            )}
            {mainHeaderText && <h1>{mainHeaderText}</h1>}
            <div className={cx('textButtonWrapper')}>
              {subText && <p className={cx('subText')}>{subText}</p>}
              <div className={cx('buttonWrapper')}>
                <PrimaryButton
                  onClick={handleOpenModal}
                  text={ui.signUpNewsletter}
                  dataCalendlyTrigger={false}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <NewsletterModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
} 